module.exports = __webpack_public_path__ + "img/watch5.ea8412be.png";